import React, { useState } from 'react';
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { ColumnSortOption } from '../../../Component/Model/Dto/ColumnSortOption';
import { useHistory } from 'react-router-dom';
import { VAClientApplicationTable } from "./VerificationAgencyClientApplicationTableMapper";
import { ApplicationDataModal } from "./ApplicationDataModal";

interface IVAClientApplicationData {
    results: VAClientApplicationTable;
    entriesPerPage: EntriesPerPage;
    pageNumber: number;
    filteredItemsCount: number;
    totalItemsCount: number;
    entriesPerPageChanged: (entriesPerPage: number) => void;
    pageNumberChanged: (pageNumber: number) => void;
    searchValueChanged: (searchValue: string) => void;
    columnSortingChanged: (sortOption: ColumnSortOption) => void;
    isLoading: boolean;
    addSelectedClientApplication: () => void;
    clientSelected: boolean;
}


export const VerificationAgencyClientApplicationTable = (props: IVAClientApplicationData) => {

    const history = useHistory();
    const [showApplicationDataModal, setShowApplicationDataModal] = useState<boolean>(false);

    const handleAddApplication = () => {
        if (props.clientSelected) {
            props.addSelectedClientApplication();
        }
        else {
            setShowApplicationDataModal(true);
        }

    }

    const closeApplicationDataModal = () => {
        setShowApplicationDataModal(false);
    }

    const bulkActions = [
        {
            label: "Add Application",
            action: handleAddApplication
        }
    ]

    return (
        <>
            <DataTable
                key={props.totalItemsCount}
                table={props.results}
                canSearch
                entriesPerPage={props.entriesPerPage}
                pageNumber={props.pageNumber}
                filteredItemsCount={props.filteredItemsCount}
                totalItemsCount={props.totalItemsCount}
                entriesPerPageChanged={props.entriesPerPageChanged}
                pageNumberChanged={props.pageNumberChanged}
                searchValueChanged={props.searchValueChanged}
                isLoading={props.isLoading}
                bulkActions={bulkActions}
                manualSorting={true}
                columnSortingChanged={props.columnSortingChanged}
            ></DataTable>

            {showApplicationDataModal && <ApplicationDataModal showApplicationDataModal={showApplicationDataModal} closeApplicationDataModal={closeApplicationDataModal} />}
        </>
    )


}

